// extracted by mini-css-extract-plugin
module.exports = {"btn":"header-dev-auth_btn__3Iwx4"};